import { useTranslation } from "react-i18next";
import { ButtonGroup, Button } from "reactstrap";

const SUPPORTED_LANGUAGES: ReadonlyArray<{ code: string; label: string }> = [
  { code: "de", label: "DE" },
  { code: "fr", label: "FR" },
  { code: "en", label: "EN" },
];

interface Props {
  size?: "sm" | "lg";
  className?: string;
}

/**
 * Compact language switcher (DE / FR / EN).
 *
 * Used both on pre-login screens (rendered inside the global Header) and in the user profile,
 * so the language can be changed before logging in / registering as well as afterwards.
 */
export function LanguageSwitcher({ size = "sm", className }: Props) {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "de")
    .slice(0, 2)
    .toLowerCase();

  return (
    <ButtonGroup
      size={size}
      className={className}
      aria-label={t("language.switcherAriaLabel")}
    >
      {SUPPORTED_LANGUAGES.map(({ code, label }) => {
        const active = current === code;
        return (
          <Button
            key={code}
            color={active ? "primary" : "secondary"}
            outline={!active}
            active={active}
            aria-pressed={active}
            onClick={() => {
              if (!active) {
                i18n
                  .changeLanguage(code)
                  .catch((e) => console.warn("Language switch failed", e));
              }
            }}
          >
            {label}
          </Button>
        );
      })}
    </ButtonGroup>
  );
}
